import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=9c7c0b4a&scoped=true"
import script from "./Hint.vue?vue&type=script&lang=js"
export * from "./Hint.vue?vue&type=script&lang=js"
import style0 from "./Hint.vue?vue&type=style&index=0&id=9c7c0b4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7c0b4a",
  null
  
)

export default component.exports